/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Product } from 'rest-client';

import {
  START_HOUR_PICKER_ID,
  END_HOUR_PICKER_ID,
  MINUTES_RANGE,
  HOURS_RANGE,
} from '@shared/const/hour-picker.const';

import { HourSelected } from '../../models/hour-selected.model';

@Component({
  host: {
    '(document:click)': 'outClick($event)',
  },
  selector: 'bkg-hour-picker',
  templateUrl: './hour-picker.component.html',
})
export class HourPickerComponent implements OnChanges {
  @Output() hourSelectedReturn = new EventEmitter<HourSelected>();
  @Output() outClickReturn = new EventEmitter<boolean>();

  @Input() hourPickerId: string;
  @Input() selectedHour: HourSelected;
  @Input() customHours: Array<string>;
  @Input() customRange: any;
  @Input() product: Product;
  @Input() set visible(value: boolean) {
    this.isVisible = value;
  }

  startHourPickerId = START_HOUR_PICKER_ID;
  endHourPickerId = END_HOUR_PICKER_ID;

  isVisible: boolean;
  showInfo = false;
  displayBack = false;
  hours = HOURS_RANGE();
  minutes = MINUTES_RANGE;

  constructor(
    private _el: ElementRef,
    private translateService: TranslateService
  ) {}

  ngOnChanges(): void {
    if (this.customRange && this.hours.length === 24) {
      const startIndex = Number(this.customRange?.close?.split(':')[0]);
      const endIndex = Number(this.customRange?.open?.split(':')[0] - 1);
      this.hours.splice(startIndex, endIndex);
    } else if (!this.customRange && this.hours.length !== 24) {
      this.hours = HOURS_RANGE();
    }
    if (this.isVisible && this.selectedHour) {
      let currentSelected = document.querySelector(
        '[id^="' + this.hourPickerId + '"].selected'
      );
      if (!currentSelected) {
        const hour =
          this.selectedHour.hours === 0
            ? '00'
            : this.selectedHour.hours.toString();
        const min =
          this.selectedHour.minutes === 0
            ? '00'
            : this.selectedHour.minutes.toString();
        const idTdSelector = `${this.hourPickerId}${hour}:${min}`;
        const tag = document.getElementById(idTdSelector);
        if (tag) tag.className = 'selected';
        currentSelected = document.querySelector(
          '[id^="' + this.hourPickerId + '"].selected'
        );
      }
      setTimeout(() => {
        if (currentSelected)
          currentSelected.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
      }, 100);
    }
  }

  get getInfoText(): string {
    if (this.product?.id === 3) {
      return this.translateService.instant(
        'sharedModule.bkgHourPicker.infoShip'
      ) as string;
    }
    return this.translateService.instant(
      'sharedModule.bkgHourPicker.info'
    ) as string;
  }

  onSelectHour(h: number, m: string): void {
    const idTdSelector = `${this.hourPickerId}${h}:${m}`;
    this.changeTdSelectorStyle(idTdSelector);

    const selectedHours: HourSelected = { hours: h, minutes: Number(m) };
    this.hourSelectedReturn.emit(selectedHours);
  }

  onSelectHourTime(time: string): void {
    const selected = time.split(':');
    const h = Number(selected[0]);
    const m = Number(selected[1]);
    const idTdSelector = `${this.hourPickerId}${h}:${m}`;
    this.changeTdSelectorStyle(idTdSelector);

    const selectedHours: HourSelected = { hours: h, minutes: Number(m) };
    this.hourSelectedReturn.emit(selectedHours);
  }

  private changeTdSelectorStyle(name: string): void {
    const allTdSelectors = document.querySelectorAll('td');
    allTdSelectors.forEach((td: HTMLTableDataCellElement) => {
      td.className = '';
    });
    const tag = document.getElementById(name);
    if (tag) {
      tag.className = 'selected';
    }
  }

  outClick(event: Event): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!this._el.nativeElement.contains(event.target)) {
      this.outClickReturn.emit(true);
    }
  }

  flipCard(): void {
    this.showInfo = false;
    setTimeout(() => {
      this.displayBack = false;
    }, 1000);
  }

  get hourPickerVisibility(): string {
    return this.isVisible ? 'block' : 'none';
  }

  get cardFlip(): string {
    return this.showInfo ? 'card is-flipped' : 'card';
  }
}
